












import Vue from "vue";
import VueMarkdownPlus from "vue-markdown-plus";

export default Vue.extend({
  name: "Markdown",
  props: {
    source: String
  },
  components: {
    VueMarkdownPlus
  },
  methods: {
    postrender: function(html: string) {
      // TODO this is a hacky way to use the router for local links in the markdown
      return html.replace(
        /<a href="(\/[^"]+)">([^<]+)<\/a>/g,
        '<a href="$1" target="_self" onclick="event.preventDefault(); vue.$router.push(\'$1\');">$2</a>'
      );
    }
  }
});
